import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function PonyvaKeszites() {
  return (
    <SubPageLayout
      eyebrow="Járműponyva-készítés"
      title="Járműponyva-készítés rövid határidővel."
      intro="Új teherautó-, kamion- vagy utánfutó ponyva belga és német alapanyagból, helyszíni méretvétellel és egyedi feliratozással. Telephelyünk M0/M5 mellett, Dunaharasztin."
      heroImage="/assets/gallery/palletways-01.jpg"
      bullets={[
        { title: "Ingyenes felmérés", text: "Pontos méretvétel és ajánlat – kötelezettség nélkül." },
        { title: "Minőségi alapanyagok", text: "Prémium PVC ponyva, széles színválasztékban." },
        { title: "Munkáinkra garanciát vállalunk", text: "Kivitelezésre és javításra egyaránt." },
      ]}
      gallery={SITE_IMAGES.truckGallery}
    />
  );
}
